var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.75,62.88c0-9.28-4.16-14-14.41-16.87-7.22-2.02-9.25-4.9-9.25-8.63s2.29-7.92,7.74-7.92c6.18,0,7.74,3.58,7.74,7.23,0,1.88,1.36,3.65,3.65,3.65s3.65-1.92,3.65-3.65c0-5.99-3.79-12.44-11.21-14.11v-3.97c0-2.02-1.64-3.65-3.65-3.65s-3.65,1.64-3.65,3.65v3.87c-7.67,1.49-11.58,7.95-11.58,14.9s3.17,13.02,13.91,16.41c5.98,1.89,9.14,3.83,9.14,9.3,0,4.28-3.36,7.55-7.82,7.55-5.35,0-8-3.13-8-6.55,0-1.76-1.47-3.65-3.69-3.65s-4.05,1.98-4.05,3.65c0,6.9,4.12,12.9,12.08,14.26v3.84c0,2.02,1.64,3.65,3.65,3.65s3.65-1.64,3.65-3.65v-3.86c8.09-1.42,12.08-7.55,12.08-15.45Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeMoney);
export default __webpack_public_path__ + "static/media/acae_money.fcf6413a.svg";
export { ForwardRef as ReactComponent };